import { render, staticRenderFns } from "./editBox.vue?vue&type=template&id=3a49c169&scoped=true"
import script from "./editBox.vue?vue&type=script&lang=js"
export * from "./editBox.vue?vue&type=script&lang=js"
import style0 from "./editBox.vue?vue&type=style&index=0&id=3a49c169&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a49c169",
  null
  
)

export default component.exports